import { useThemeTokens } from '@providers/themeTokenProvider';

export type AlertTokenSeverity = {
  success?: {
    color?: string;
    backgroundColor?: string;
    borderColor?: string;
    fontColor?: string;
  };
  info?: {
    color?: string;
    backgroundColor?: string;
    borderColor?: string;
    fontColor?: string;
  };
  warning?: {
    color?: string;
    backgroundColor?: string;
    borderColor?: string;
    fontColor?: string;
  };
  error?: {
    color?: string;
    backgroundColor?: string;
    borderColor?: string;
    fontColor?: string;
  };
};

export type AlertTokens = {
  alert: {
    standard?: AlertTokenSeverity;
    filled?: AlertTokenSeverity;
    outlined?: AlertTokenSeverity;
  };
};

export const useAlertTokens = (): AlertTokens => {
  const baseTokens = useThemeTokens();
  const { sys } = baseTokens;

  const comp: AlertTokens = {
    alert: {
      standard: {
        success: {
          color: sys.color.positive,
          backgroundColor: sys.color.positiveVariant,
          fontColor: sys.color.onSurface,
        },
        info: {
          color: sys.color.primary,
          backgroundColor: sys.color.primaryVariant,
          fontColor: sys.color.onSurface,
        },
        warning: {
          color: sys.color.warning,
          backgroundColor: sys.color.warningVariant,
          fontColor: sys.color.onSurface,
        },
        error: {
          color: sys.color.negative,
          backgroundColor: sys.color.negativeVariant,
          fontColor: sys.color.onSurface,
        },
      },
      filled: {
        success: {
          color: sys.color.positive,
          backgroundColor: sys.color.positiveVariant,
          fontColor: sys.color.onSurface,
        },
        info: {
          color: sys.color.primary,
          backgroundColor: sys.color.primaryVariant,
          fontColor: sys.color.onSurface,
        },
        warning: {
          color: sys.color.warning,
          backgroundColor: sys.color.warningVariant,
          fontColor: sys.color.onSurface,
        },
        error: {
          color: sys.color.negative,
          backgroundColor: sys.color.negativeVariant,
          fontColor: sys.color.onSurface,
        },
      },
      outlined: {
        success: {
          color: sys.color.positive,
          backgroundColor: sys.color.positiveVariant,
          borderColor: sys.color.positiveVariantPressed,
          fontColor: sys.color.onSurface,
        },
        info: {
          color: sys.color.primary,
          backgroundColor: sys.color.primaryVariant,
          borderColor: sys.color.primaryVariantPressed,
          fontColor: sys.color.onSurface,
        },
        warning: {
          color: sys.color.warning,
          backgroundColor: sys.color.warningVariant,
          borderColor: sys.color.warningVariantPressed,
          fontColor: sys.color.onSurface,
        },
        error: {
          color: sys.color.negative,
          backgroundColor: sys.color.negativeVariant,
          borderColor: sys.color.negativeVariantPressed,
          fontColor: sys.color.onSurface,
        },
      },
    },
  };

  return comp;
};
